import React from "react";
import { Range } from "react-range";

export default function Input({ value, setValue, label, min = 0, max = 1000 }) {
  return (
    <div className="rounded-m my-1 flex flex-col">
      <h1 className="tracking-tight my-2 xs:text-2xl text-sm text-center">
        {label}
      </h1>
      <h1 className="font-semibold tracking-tight xs:text-2xl text-center">
        {value}
      </h1>
      <Range
        step={1}
        min={min}
        max={max}
        values={[value]}
        onChange={(values) => setValue(values)}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            className="bg-indigo-500 rounded-md my-5 shadow-lg"
            style={{
              ...props.style,
              height: "6px",
              width: "100%"
            }}
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className="focus:outline-none bg-indigo-600"
            style={{
              ...props.style,
              height: "24px",
              width: "24px",
              borderRadius: "24px"
            }}
          ></div>
        )}
      />
    </div>
  );
}
